export class Login {
    email: string;
    senha: string;
    token: string;
    urlAcesso: string;
    senhaReanimacao: string;
    viaWeb: boolean;
}